import copy from "copy-to-clipboard";

const globalWindow: Window | false =
  typeof window === "object"
    ? window
    : // istanbul ignore next - no need to test
      false;

/**
 * An isomorphic function that copies a piece of text to the clipboard
 * in a multi-browser compatible way.
 *
 * @param text Text to copy to the clipboard
 */
export default function copyToClipboard(
  text: string,
  // istanbul ignore next - ARCH-227
  window: Window | boolean = globalWindow
): void {
  // istanbul ignore next - early return for isomorphism
  if (typeof window !== "object") {
    return;
  }
  // all browsers supported
  copy(text);
}

export const handleCopy = (
  text: string,
  toastSuccess: Function,
  t: Function
) => {
  return (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    copyToClipboard(text);
    toastSuccess(t("common:actions.copiedToClipboard"));
  };
};
